<template>
  <div style="padding: 14px 16px">
    <div style="display: flex; align-items: center; margin-bottom: 20px">
      <div
        style="width: 2px; height: 12px; background: #107fff; margin-right: 6px"
      ></div>
      <span style="font-size: 14px; color: #171a1d">流程节点</span>
      <el-popover
        placement="bottom"
        width="200"
        trigger="click"
        style="margin-left: auto"
        v-model="urge"
        v-if="flowLogList[0].nodeName !== '结束'"
      >
        <div
          style="font-size: 12px; color: #107fff; cursor: pointer"
          slot="reference"
        >
          <img
            src="https://ybr-test.oss-cn-shanghai.aliyuncs.com/public/images/容器@2x (11).png"
            alt=""
            style="width: 16px; height: 16px; vertical-align: middle"
          />
          一键催办
        </div>
        <div>
          <el-input type="textarea" v-model="urgeText" :rows="3"></el-input>
          <div style="margin-top: 10px; text-align: end">
            <el-button size="mini" @click="urge = false">取消</el-button>
            <el-button type="primary" size="mini" @click="handleUrge"
              >确定</el-button
            >
          </div>
        </div>
      </el-popover>
    </div>
    <div
      class="flowLogNode"
      v-for="(item, index) in flowLogList"
      :key="item.nodeCode + index"
    >
      <div class="center icon">
        <svg-icon
          icon-class="icon_flow_end"
          style="font-size: 22px"
          v-if="item.status === 'AGREE' && item.nodeType === 'END'"
        ></svg-icon>
        <svg-icon
          icon-class="icon_flow_cc"
          style="font-size: 22px"
          v-else-if="item.status === 'NO_EXECUTE' && item.nodeType === 'CC'"
        ></svg-icon>
        <img
          :src="item.taskList[item.taskList.length - 1].executorAvatar"
          alt=""
          style="width: 100%; height: 100%; border-radius: 6px"
          v-else
        />

        <svg-icon
          v-if="item.status === 'REFUSE'"
          icon-class="icon_flow_refuse"
          style="font-size: 15px; position: absolute; left: 31px; top: 27px"
        ></svg-icon>
        <svg-icon
          v-else-if="item.status === 'NO_EXECUTE' && item.nodeType === 'CC'"
          icon-class="icon_flow_execute"
          style="display: none"
        ></svg-icon>
        <svg-icon
          v-else-if="item.status === 'NO_EXECUTE'"
          icon-class="icon_flow_execute"
          style="font-size: 15px; position: absolute; left: 31px; top: 27px"
        ></svg-icon>
        <svg-icon
          v-else
          icon-class="icon_flow_agree"
          style="font-size: 15px; position: absolute; left: 31px; top: 27px"
        ></svg-icon>
      </div>
      <div
        class="title line-height: 16px"
        :style="{
          height:
            item.status === 'AGREE' && item.nodeType === 'END' ? '40px' : '',
        }"
      >
        <span
          style="font-size: 14px; font-weight: 500"
          :style="{
            color:
              item.status === 'AGREE' && item.nodeType === 'END'
                ? '#8893A7'
                : '#171a1d',
            marginTop:
              item.status === 'AGREE' && item.nodeType === 'END' ? '4px' : '',
          }"
        >
          {{ item.nodeName }}
        </span>
        <span style="font-size: 12px; color: #8893a7">{{
          item.taskList[item.taskList.length - 1].ended
        }}</span>

        <!-- <div
          style="margin-left: auto; cursor: pointer"
          v-if="!['ROOT', 'END'].includes(item.nodeType)"
        >
          <i
            class="el-icon-arrow-up"
            v-if="item.isShowComment"
            @click="$set(item, 'isShowComment', false)"
          ></i>
          <i
            class="el-icon-arrow-down"
            v-else
            @click="$set(item, 'isShowComment', true)"
          ></i>
        </div> -->
      </div>
      <div>
        <span
          v-if="item.nodeType === 'CC'"
          class="status"
          style="font-size: 14px; color: #8893a7; line-height: 16px"
          >抄送{{ item.taskList.length }}人</span
        >
      </div>
      <div
        class="comment"
        v-if="item.nodeType === 'CC'"
        style="background: #fff; width: fit-content; display: flex; gap: 15px"
      >
        <div
          v-for="info in item.taskList.filter((f) => f.nodeCode !== 'END')"
          :key="info.id"
        >
          <el-tooltip
            class="item"
            effect="dark"
            :content="info.executorName"
            placement="top"
          >
            <div style="position: relative; width: 32px; height: 32px">
              <img
                :src="info.executorAvatar"
                alt=""
                style="width: 32px; height: 32px; border-radius: 50%"
                v-if="info.executorAvatar"
              />
              <div v-else class="photo center rounded">
                {{ info.executorName?.substring(info.executorName.length - 2) }}
              </div>
              <img
                src="https://static.h3yun.com/common-resource/pc/form-detail/images/finish.svg"
                alt=""
                style="
                  position: absolute;
                  bottom: 0;
                  right: -3px;
                  width: 12px;
                  height: 12px;
                "
                v-if="info.status === 'READED'"
              />
              <img
                v-else
                src="https://static.h3yun.com/common-resource/pc/form-detail/images/working.svg"
                style="
                  position: absolute;
                  bottom: 0;
                  right: -3px;
                  width: 12px;
                  height: 12px;
                "
                alt=""
              />
            </div>
          </el-tooltip>
        </div>
      </div>
      <template v-else>
        <div
          v-for="info in item.taskList.filter((f) => f.nodeCode !== 'END')"
          :key="info.id"
        >
          <div class="info" v-if="item.nodeType !== 'CC'">
            <span style="font-size: 14px; color: #8893a7">{{
              info.executorName
            }}</span>

            <span
              class="status"
              :style="{
                color:
                  setFlowText(info.nodeType, info.status) === '不同意'
                    ? '#FF4F4F'
                    : setFlowText(info.nodeType, info.status) === '进行中'
                    ? '#FF943E'
                    : '#00d495',
              }"
              >({{ setFlowText(info.nodeType, info.status) }})</span
            >
          </div>
          <div class="comment" v-if="!item.isShowComment && info.comment">
            {{ info.comment }}
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "flowLog",
  props: {
    flowLogList: {
      type: Array,
      default: () => [],
    },
  },
  created() {
    console.log(this.flowLogList);
  },
  data() {
    return {
      urgeText: `尊敬的领导，您有一条【${this.$store.state.formData.pageNameList[0].formName}】的任务需要您尽快处理`,
      urge: false,
    };
  },
  methods: {
    handleUrge() {
      this.$emit("handleUrge", this.urgeText);
      this.urge = false;
    },

    flowTilteText(nodeType, status) {
      if (nodeType === "ROOT") return "提交";
      else if (nodeType === "APPROVAL" && status === "AGREE") return "已审批";
      else if (nodeType === "APPROVAL" && status === "NO_EXECUTE")
        return "进行中";
      else if (nodeType === "CC" && status === "AGREE") return "抄送";
      else if (nodeType === "APPROVAL" && status === "REFUSE") return "已驳回";
      else if (nodeType === "CC" && status === "CANCEL") return "已取消";
      else if (nodeType === "END") return "已结束";
    },
    setFlowText(nodeType, status) {
      if (nodeType === "ROOT") return "提交";
      else if (nodeType === "APPROVAL" && status === "AGREE") return "同意";
      else if (nodeType === "APPROVAL" && status === "NO_EXECUTE")
        return "进行中";
      else if (nodeType === "APPROVAL" && status === "DELIVER") return "转交";
      else if (nodeType === "CC" && status === "AGREE") return "已读";
      else if (nodeType === "CC" && status === "NO_EXECUTE") return "未读";
      else if (nodeType === "APPROVAL" && status === "REFUSE") return "不同意";
      else if (nodeType === "CC" && status === "CANCEL") return "已取消";
      else if (nodeType === "END") return "已结束";
    },
  },
};
</script>

<style scoped lang="less">
/deep/ .el-step__icon-inner[class*="el-icon"]:not(.is-status) {
  font-size: 18px;
}

/deep/ .el-step.is-vertical .el-step__line {
  width: 1px;
}

.flowLogNode {
  border-radius: 5px;
  color: #000;
  margin-bottom: 38px;
  position: relative;
  margin-left: 58px;
  .icon {
    position: absolute;
    left: -58px;
    top: 0;
    width: 40px;
    height: 40px;
    border-radius: 6px;
    background: #107fff;
  }
  &::after {
    position: absolute;
    height: calc(100% - 13px);
    content: "";
    left: -38px;
    top: 44px;
    border: 1px solid #dce3eb;
  }
  &:last-child {
    &::after {
      display: none;
    }
  }
  .title {
    display: flex;
    justify-content: space-between;
  }
  .info {
    padding-top: 4px;
    display: flex;
    align-items: center;
    line-height: 1;
    .avatar {
      vertical-align: middle;
      width: 24px;
      height: 24px;
      border-radius: 50%;
    }
    .avatarText {
      display: inline-block;
      width: 24px;
      height: 24px;
      font-size: 12px;
      line-height: 24px;
      border-radius: 50%;
      text-align: center;
      background: #1890ff;
      color: white;
    }
    .status {
      font-size: 14px;
      margin-left: 4px;
    }
  }
  .comment {
    background: #f6f8fb;
    border-radius: 4px;
    padding: 11px 12px;
    font-size: 15px;
    margin-top: 10px;
    color: #777b80;
  }
}
/deep/ .el-icon-circle-close:before {
  color: red;
}

.photo {
  width: 32px;
  height: 32px;
  background: #107fff;
  color: #fff;
  border: 1px solid #ffffff;
  margin-left: 24px;
  font-size: 13px;
  line-height: 20px;
  cursor: pointer;
}
</style>